export default {
  SET_ERROR: 'SET_ERROR',
  RESET_ERROR: 'RESET_ERROR',
  SET_INFO: 'SET_INFO',
  RESET_INFO: 'RESET_INFO',
  SET_SUCCESS_MESSAGE: 'SET_SUCCESS_MESSAGE',
  RESET_SUCCESS_MESSAGE: 'RESET_SUCCESS_MESSAGE',
  SET_MITRA_DETAILS: 'SET_MITRA_DETAILS',
  IS_API_PROGRESS: 'IS_API_PROGRESS',
  TOGGLE_REVIEW: 'TOGGLE_REVIEW',
  TOGGLE_ADD_REVIEW: 'TOGGLE_ADD_REVIEW',
  IS_SUBMITTING_REVIEW: 'IS_SUBMITTING_REVIEW',
  IS_FETCHING_REVIEWS: 'IS_FETCHING_REVIEWS',
  SET_REVIEWS: 'SET_REVIEWS',
  IS_SUBMITTING_VOTE: 'IS_SUBMITTING_VOTE',
};
